import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22b48b88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import "./index.vue?vue&type=style&index=0&id=22b48b88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b48b88",
  null
  
)

export default component.exports